import { FunctionComponent } from 'react';
import BloqueEnDesarrollo from '../../components/BloqueEnDesarrollo';
import Bloque1Penetracion from '../../components/Bloque1Penetracion';
import Bloque2ATreemapGd from '../../components/Bloque2ATreemapGd';
import Bloque2BEvolucionGd from '../../components/Bloque2BEvolucionGd';
import '../../css/PrivateStatisticsPage.css';

const PrivateStatisticsPage: FunctionComponent = () => {
  return (
    <div className='private-statistics-page-container vdr-stats'>
      <header className='vdr-page-head vdr-stats-page-head'>
        <div className='vdr-page-head__titles'>
          <span className='vdr-eyebrow vdr-eyebrow--bar'>VisiónDERRED · Panel de indicadores</span>
          <h2 className='vdr-page-head__title private-statistics-page-title'>
            Estadísticas del Sector
          </h2>
        </div>
        <small className='vdr-page-head__tag'>Adopción · GD · Estudios</small>
      </header>

      <Bloque1Penetracion />

      <section className='estadisticas-gd-bloque'>
        <header className='estadisticas-gd-bloque-header'>
          <h3 className='estadisticas-gd-bloque-titulo'>
            2. Generación distribuida en Chile (PMGD y EG netbilling)
          </h3>
          <small className='vdr-stats-bloque-tag' aria-hidden='true'>
            Parque GD
          </small>
          <p className='estadisticas-gd-bloque-subtitulo'>
            Composición del parque instalado por tecnología y comuna, y evolución mensual del parque
            por región y comuna.
          </p>
        </header>

        <div className='estadisticas-gd-subbloque'>
          <h4 className='estadisticas-gd-subbloque-titulo'>
            2.A · Composición por tecnología y comuna
          </h4>
          <p className='estadisticas-gd-subbloque-descripcion'>
            Cada celda representa la capacidad instalada agregada de una comuna. El color codifica
            la tecnología.
          </p>
          <div className='estadisticas-gd-fuentes-row'>
            <Bloque2ATreemapGd fuente='pmgd' titulo='PMGD' />
            <Bloque2ATreemapGd fuente='eg' titulo='EG (netbilling)' />
          </div>
        </div>

        <div className='estadisticas-gd-subbloque'>
          <h4 className='estadisticas-gd-subbloque-titulo'>
            2.B · Evolución mensual del parque
          </h4>
          <p className='estadisticas-gd-subbloque-descripcion'>
            Series acumuladas mensuales de cantidad y capacidad de proyectos, apiladas por
            tecnología.
          </p>
          <Bloque2BEvolucionGd fuente='pmgd' titulo='PMGD' />
          <Bloque2BEvolucionGd fuente='eg' titulo='EG (netbilling)' />
        </div>
      </section>

      <section className='estadisticas-gd-bloque'>
        <header className='estadisticas-gd-bloque-header'>
          <h3 className='estadisticas-gd-bloque-titulo'>
            3. Resultados de capacidad de alojamiento
          </h3>
          <small className='vdr-stats-bloque-tag' aria-hidden='true'>
            Estudios
          </small>
          <p className='estadisticas-gd-bloque-subtitulo'>
            Resúmenes y resultados representativos de los estudios de capacidad de alojamiento
            ejecutados sobre la red.
          </p>
        </header>
        <BloqueEnDesarrollo
          titulo='En desarrollo'
          descripcion='Esta sección se incorporará en una iteración posterior. Mostrará indicadores y resultados representativos de estudios ejecutados sobre redes modeladas en VisiónDERRED.'
        />
      </section>
    </div>
  );
};

export default PrivateStatisticsPage;
